import { postClicksDistributionConfig } from '@/lib/analytics/charts/facebook/mediaViewer/postClicksDistributionConfig';
import { clicksMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/clicks';
import { commentsMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/comments';
import { engagementRateFollowersMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/engagementRateFollowers';
import { engagementReachMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/engagementReach';
import { impressionsViewsMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/impressionsViews';
import { reachMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/reach';
import { reachRateFollowersMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/reachRateFollowers';
import { reactionsMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/reactions';
import { reelsAvgTimeWatchedMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/reelsAvgTimeWatched';
import { reelsCommentsMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/reelsComments';
import { reelsPlaysMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/reelsPlays';
import { reelsReachMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/reelsReach';
import { reelsReachRateMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/reelsReachRate';
import { reelsReactionsMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/reelsReactions';
import { reelsSharesMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/reelsShares';
import { reelsTotalTimeWatchedMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/reelsTotalTimeWatched';
import { sharesMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/shares';
import { videoViews3SecMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/videoViews3Sec';
import { videoViews10SecMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/videoViews10Sec';
import { videoViewsAvgTimeWatchedMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/videoViewsAvgTimeWatched';
import { videoViewsCompleteMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/videoViewsComplete';
import { videoViewsTotalTimeMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/videoViewsTotalTime';
import { FB_POST_TYPES, POST } from '@/lib/posts/postTypes';

export const MediaViewerStatsFacebook = {
    [POST]: {
        [FB_POST_TYPES.TYPE_PHOTO]: [
            reactionsMVConfig,
            commentsMVConfig,
            impressionsViewsMVConfig,
            reachMVConfig,
            sharesMVConfig,
            clicksMVConfig,
            engagementReachMVConfig,
            engagementRateFollowersMVConfig,
            reachRateFollowersMVConfig,
            postClicksDistributionConfig
        ],
        [FB_POST_TYPES.TYPE_VIDEO]: [
            videoViewsCompleteMVConfig,
            videoViews3SecMVConfig,
            videoViews10SecMVConfig,
            videoViewsTotalTimeMVConfig,
            videoViewsAvgTimeWatchedMVConfig,
            reactionsMVConfig,
            commentsMVConfig,
            impressionsViewsMVConfig,
            reachMVConfig,
            sharesMVConfig,
            clicksMVConfig,
            engagementReachMVConfig,
            reachRateFollowersMVConfig,
            engagementRateFollowersMVConfig,
            postClicksDistributionConfig
        ],
        [FB_POST_TYPES.TYPE_STATUS]: [
            reactionsMVConfig,
            commentsMVConfig,
            impressionsViewsMVConfig,
            reachMVConfig,
            sharesMVConfig,
            clicksMVConfig,
            engagementReachMVConfig,
            engagementRateFollowersMVConfig,
            reachRateFollowersMVConfig,
            postClicksDistributionConfig
        ],
        [FB_POST_TYPES.TYPE_STORY]: [
            reactionsMVConfig,
            commentsMVConfig,
            impressionsViewsMVConfig,
            reachMVConfig,
            sharesMVConfig,
            clicksMVConfig,
            engagementReachMVConfig,
            reachRateFollowersMVConfig,
            engagementRateFollowersMVConfig,
            postClicksDistributionConfig
        ],
        [FB_POST_TYPES.TYPE_REEL]: [
            reelsPlaysMVConfig,
            reelsReactionsMVConfig,
            reelsTotalTimeWatchedMVConfig,
            reelsAvgTimeWatchedMVConfig,
            reelsCommentsMVConfig,
            reelsSharesMVConfig,
            engagementRateFollowersMVConfig,
            reelsReachMVConfig,
            reelsReachRateMVConfig
        ]
    }
};
